export enum OrderProductKind  {
	Product = 'Product',
	Shipment = 'Shipment',
	AdditionalService = 'AdditionalService'
}
//TODO:ROZMOWA zmienić mapowanie przy [ppopbieraniu] zamowienia (spradzic czy tylko w tym miejscu to jest) na kind produktu z s123 (merchs | service)